<template>
  <div :style="{ backgroundColor : settings.sideTheme === 'theme-dark' ? variables.menuBg : variables.menuLightBg }">
    <el-scrollbar :class="settings.sideTheme"
                  wrap-class="scrollbar-wrapper"
    >
      <el-menu :active-text-color="settings.theme"
               :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBg : variables.menuLightBg"
               :collapse="isCollapse"
               :collapse-transition="false"
               :default-active="activeMenu"
               :text-color="settings.sideTheme === 'theme-dark' ? variables.menuText : 'rgba(0,0,0,.65)'"
               :unique-opened="true"
               mode="vertical"
      >
        <template v-for="(route, index) in sidebarRouters">
          <sidebar-item v-if="!route.hidden"
                        :key="route.path  + index"
                        :base-path="route.path"
                        :item="route"
          />
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex';
  import SidebarItem from './sidebar-item';
  import variables from '@/assets/styles/variables.scss';

  export default {
    components: { SidebarItem },
    computed: {
      ...mapState(['settings']),
      ...mapGetters(['sidebarRouters', 'sidebar']),
      activeMenu() {
        const route = this.$route;
        const { meta, path } = route;
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu;
        }
        return path;
      },
      variables() {
        return variables;
      },
      isCollapse() {
        return !this.sidebar.opened;
      }
    }
  };
</script>
